let defaultHeaders = {};

const wrappedFetch = function (url, params = {}) {

	let online = window.navigator.onLine;

	if (!online)
		window.location.href = "/offline.html";

	params.headers = Object.assign(
		{},
		headerDict(params.headers),
		defaultHeaders
	);
	params.credentials = 'same-origin';

	var gotServerError = false;
	var link = url;
		return fetch(url, params).then((response) => 
		{
			//if (IS_DEV) console.log("fetched:", response);
			if (response.redirected)
			{
				window.location.href = response.url;
			}
			if (!response.ok)
			{
				//if (IS_DEV) console.log("status of response is not OK.");
				gotServerError = true;
				var explain = (response.statusText == null || response.statusText.length === 0) ? " Problem with request." : response.statusText; // status text will only give 'Ok', 'Bad Request' etc
				explain += "/url=" + link + "/" + response.json();
				throw new Error(explain);
			}
			return response;
		})
		.then((response) => {
			dispatchEvent(new window.CustomEvent('fetch-end'));
			return response;
		})
		.catch((ex) => {
			//if (IS_DEV) console.log("Problem: [" + ex.message + "]");
			dispatchEvent(new window.CustomEvent('fetch-error', {
				detail: {
					exception: ex
				}
			}));

			if (!gotServerError)
				window.location.href = "/offline.html";
			throw ex;
		});
}

const headerDict = function (headers) {
	let dict = {};

	if (headers instanceof Headers) {
		for (let [key, value] of headers.entries()) {
			dict[key] = value;
		}
	} else {
		dict = headers;
	}

	return dict;
}

wrappedFetch.setDefaultHeaders = function (headers) {
	defaultHeaders = headerDict(headers);
}

wrappedFetch.onError = null;

wrappedFetch.throwErrors = function (response) {
	if (!response.ok) {
		const err = new Error(response.statusText);
		err.response = response;
		throw err;
	}
	return response;
}

module.exports = wrappedFetch;
